export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
